import { render, staticRenderFns } from "./Education.vue?vue&type=template&id=745e69a2&scoped=true&"
import script from "./Education.vue?vue&type=script&lang=js&"
export * from "./Education.vue?vue&type=script&lang=js&"
import style0 from "./Education.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Education.vue?vue&type=style&index=1&id=745e69a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745e69a2",
  null
  
)

export default component.exports